<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint"/>

    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      title="안전보건관리체계 구축 현황 점검표"
      :is-note="false"
      :list="form.inspectList"
      @update-list-check="updateListCheck"
    />

    <!--파일첨부-->
    <file-upload-module
      :readonly="board.readonly"
      v-model="form.fileList"
      class="mt-5"
      :is-print="isPrint"
    />
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import TableInspect from '@/components/TableInspect'
import FileUploadModule from '@/views/modules/FileUploadModule.vue'

export default {
  components: { FieldSelectModule, TableInspect, FileUploadModule },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          this.form[key] = value[key]
        }

        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      },
    },
  },
  data () {
    return {
      form: {
        stdInfo: {},
        inspectList: [],
        fileList: [],
      },
      projectId : parseInt(this.$route.params.proj_id)
    }
  },
  created() {
    this.projectId = parseInt(this.$route.params.proj_id);
    this.initBreadcrumb();
  },
  computed: {
    inspectTable () {
      return [
        {
          id: 1,
          title: '1. 안전·보건 업무 관련 업무 수행 등에 따른 인력 확보',
          label: '안전보건 조직체계 + 안전보건 관리체계',
          is_checked: '',
        },
        {
          id: 2,
          title: '2. 안전·보건 업무 관련 예산 편성 및 집행',
          label: '안전보건 예산 > 안전보건 관련 예산',
          is_checked: '',
        },
        {
          id: 3,
          title: '3. 안전점검 계획 수립 및 수행',
          label: '안전보건 점검 > 안전보건 점검표',
          is_checked: '',
        },
        {
          id: 4,
          title: '4. 안전계획 수립 및 이행',
          label: '유해〮위험요인 관리 + 위험성평가',
          is_checked: '',
        },
        {
          id: 5,
          title: '4. 안전계획 수립 및 이행',
          label: '비상 연락망 게시',
          is_checked: '',
        },
        {
          id: 6,
          title: '5. 안전계획 이행 여부 점검',
          label: '안전보건 관리 > 안전점검 ',
          is_checked: '',
        },
        {
          id: 7,
          title: '6. 점검결과에 따른 조치 실시',
          label: '안전보건 관리 > 시설물 보수 보강 ',
          is_checked: '',
        },
        {
          id: 8,
          title: '7. 중대시민재해 예방을 위한 업무처리 절차 마련 및 이행',
          label: '재해발생 대비 대책 > 비상조치 및 처리 절차 안내',
          is_checked: '',
        },
        {
          id: 9,
          title: '8. 도급·용역·위탁 시 시민재해 예방 기준 및 절차마련',
          label: '안전보건 인력 > 안전보건관리 책임자 지정',
          is_checked: '',
        },
        {
          id: 10,
          title: '8. 도급·용역·위탁 시 시민재해 예방 기준 및 절차마련',
          label: '안전보건 인력 > 안전보건관리 수행평가',
          is_checked: '',
        },
        {
          id: 11,
          title: '8. 도급·용역·위탁 시 시민재해 예방 기준 및 절차마련',
          label: '재해발생 대비 대책 > 대응단계별 절차',
          is_checked: '',
        },
      ];
    },
  },
  methods: {
    updateListCheck (indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text
    },
  },
}
</script>

<style scoped></style>
